import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=29ab003b&scoped=true&"
import script from "@/scripts/spentCashback/detailView.js?vue&type=script&lang=js&"
export * from "@/scripts/spentCashback/detailView.js?vue&type=script&lang=js&"
import style0 from "./DetailView.vue?vue&type=style&index=0&id=29ab003b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab003b",
  null
  
)

export default component.exports